export default (host: string) => ({
  '@id': 'organization',
  'address': {
    '@type': 'PostalAddress',
    'addressCountry': 'CH',
    'addressLocality': 'Stabio',
    'addressRegion': 'Ticino',
    'postalCode': '6855',
    'streetAddress': 'Via Laveggio 5'
  },
  'areaServed': 'PT',
  'brand': {
    '@type': 'Brand',
    '@id': `https://${host}/pt-pt#brand`,
    'name': 'Timberland',
    'description': 'A Timberland é construída para os audazes. Inspiramos e equipamos os aventureiros para irem para o ar livre, trabalharem arduamente e fazerem o mundo avançar.',
    'url': `https://${host}/pt-pt`,
    'image': `https://${host}/img/logo50.svg`
  },
  'contactPoint': [
    {
      '@type': 'ContactPoint',
      'telephone': '800 781 344',
      'contactType': 'Telephone',
      'areaServed': 'PT',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 09:00-19:00 WEST'
    },
    {
      '@type': 'ContactPoint',
      'contactType': 'Chat',
      'areaServed': 'PT',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 09:00-19:00 WEST',
      'url': `https://${host}/pt-pt`
    }
  ],
  'logo': {
    '@id': '#logo',
    'caption': 'Timberland',
    'contentUrl': `https://${host}/img/logo50.svg`,
    'url': `https://${host}/img/logo50.svg`
  },
  'name': 'Timberland',
  'parentOrganization': 'VF Corporation (VFC)',
  'sameAs': [
    'https://www.youtube.com/timberland',
    'https://www.instagram.com/timberland',
    'https://www.facebook.com/timberland'
  ],
  'url': `https://${host}/pt-pt`
})
